var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2494 7H27.5075L26.4675 4.4C25.3988 1.72687 22.8481 0 19.9688 0H12.0313C9.15252 0 6.60127 1.72687 5.53189 4.4L4.49189 7H0.750642C0.262517 7 -0.0956082 7.45875 0.0231418 7.93188L0.398142 9.43188C0.481267 9.76563 0.781267 10 1.12564 10H2.38002C1.54064 10.7331 1.00002 11.7988 1.00002 13V16C1.00002 17.0075 1.38502 17.9169 2.00002 18.6206V22C2.00002 23.1044 2.89564 24 4.00002 24H6.00002C7.10439 24 8.00002 23.1044 8.00002 22V20H24V22C24 23.1044 24.8956 24 26 24H28C29.1044 24 30 23.1044 30 22V18.6206C30.615 17.9175 31 17.0081 31 16V13C31 11.7988 30.4594 10.7331 29.6206 10H30.875C31.2194 10 31.5194 9.76563 31.6025 9.43188L31.9775 7.93188C32.0956 7.45875 31.7375 7 31.2494 7ZM9.24564 5.88562C9.70127 4.74687 10.8044 4 12.0313 4H19.9688C21.1956 4 22.2988 4.74687 22.7544 5.88562L24 9H8.00002L9.24564 5.88562ZM6.00002 15.9875C4.80002 15.9875 4.00002 15.19 4.00002 13.9937C4.00002 12.7975 4.80002 12 6.00002 12C7.20002 12 9.00002 13.7944 9.00002 14.9906C9.00002 16.1869 7.20002 15.9875 6.00002 15.9875ZM26 15.9875C24.8 15.9875 23 16.1869 23 14.9906C23 13.7944 24.8 12 26 12C27.2 12 28 12.7975 28 13.9937C28 15.19 27.2 15.9875 26 15.9875V15.9875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.a75e13d17bcb5e79bbe2e8daf41ac1f7.svg";
export { ForwardRef as ReactComponent };